import { InjectionToken } from '@angular/core';

export const spri_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('spri_MOCK_API_DEFAULT_DELAY');
